import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UiService } from 'core/services/ui.service';
import { Preloader, PreloaderPosition } from 'core/models';
import { ActivatedRoute, Data } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['preloader.component.scss']
})
export class PreloaderComponent implements OnInit, OnDestroy {
  public position: PreloaderPosition = PreloaderPosition.Primary;
  public preloaderConfig: Preloader;
  private preloaderSubscription: Subscription = new Subscription();
  private routeSubscription: Subscription = new Subscription();

  constructor(private uiService: UiService, private activatedRoute: ActivatedRoute, private cd: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.preloaderSubscription = this.uiService.getPreloaderConfig$().subscribe((preloaderConfig: Preloader): void => {
      this.preloaderConfig = { ...preloaderConfig };
      this.cd.detectChanges();
    });

    this.routeSubscription = this.activatedRoute.data.subscribe((data: Data): void => {
      this.position = data['preloader'] || PreloaderPosition.Primary;
      this.uiService.setPreloaderConfig({ ...this.uiService.preloaderConfig, position: this.position });
    });
  }

  public ngOnDestroy(): void {
    this.preloaderSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }
}
